<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code"/></span>

				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 3%;" />
						<col style="width: 3%;" />
						<col style="width: 3%;" />
						<col style="width: 8%;" />
						<col style="width: 23%;" />
						<col style="width: 45%;" />
						<col style="width: 15%;" />
					</colgroup>
					<thead>
						<tr>
							<th colspan="5">Row Labels</th>
							<th>CLASS</th>
							<th>Sum of Balance</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="sales in root.list">
							<tr v-bind:key="sales.sales_group_code">
								<td colspan="6" class="al_left">{{ sales.sales_group_code }} / {{ sales.sales_group_name }}</td>
								<td class="al_right">{{ sales.total_amount | toCurrency }}</td>
							</tr>
							<template v-for="date in sales.dateList">
								<tr v-bind:key="sales.sales_group_code + '-' + date.date">
									<td></td>
									<td colspan="5" class="al_left">{{ date.date }}</td>
									<td class="al_right">{{ date.amount | toCurrency }}</td>
								</tr>
								<template v-for="customer in date.list">
									<tr v-bind:key="sales.sales_group_code + '-' + date.date + '-' + customer.bill_to_code">
										<td colspan="2"></td>
										<td class="al_left" colspan="2">{{ customer.bill_to_code }}</td>
										<td class="al_left" colspan="2">{{ customer.bill_to_name }}</td>
										<td class="al_right">{{ customer.amount | toCurrency }}</td>
									</tr>
									<tr v-for="invoice in customer.list" v-bind:key="sales.sales_group_code + '-' + date.date + '-' + customer.bill_to_code + '-' + invoice.invoice_no">
										<td colspan="3"></td>
										<td class="al_left">{{ invoice.invoice_dn }}</td>
										<td class="al_left">{{ invoice.description }}</td>
										<td class="al_left" style="white-space: normal; word-break: break-word;">{{ invoice.class_names }}</td>
										<td class="al_right">{{ invoice.balance | toCurrency }}</td>
									</tr>
								</template>
							</template>
						</template>
						<tr>
							<td colspan="6" class="al_right">Grand Total</td>
							<td class="al_right">{{ root.amount | toCurrency }}</td>
						</tr>

						<tr>
							<td colspan="6" class="al_right">Over 60</td>
							<td class="al_right">{{ root.total_over | toCurrency }}</td>
						</tr>

						<tr>
							<td colspan="6" class="al_right">1 ~ 30</td>
							<td class="al_right">{{ root.total_30 | toCurrency }}</td>
						</tr>

						<tr>
							<td colspan="6" class="al_right">31 ~ 60</td>
							<td class="al_right">{{ root.total_60 | toCurrency }}</td>
						</tr>

						<tr>
							<td colspan="6" class="al_right">합계 (1 ~ 60)</td>
							<td class="al_right">{{ (root.total_30 + root.total_60) | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="exportExcel()">Excel</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="reportPrint">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiImmediatePayment, apiIndex } from '@/api/report/report';
import CodeSelect from '@/components/common/CodeSelect';
import { apiGetBase64ReportTemplate, objectToFormData, Report, reportMrtUrl } from '@/api/util';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { monthAdd, today } from '@/utils/date';
import { exportExcel } from '@/api/util';

export default {
	data: function() {
		return {
			root: '',
			sales_group_code: '',
			salesGroups: [],
			from_date: monthAdd(-6),
			to_date: today(),
		};
	},
	components: {
		CodeSelect,
		CustomDatePicker,
	},
	methods: {
		async selectData() {
			// if (!this.sales_group_code) {
			// 	this.$toast.error('Sales Group not selected.');
			// 	return false;
			// }

			const paramObj = {
				sales_group_code: this.sales_group_code,
				from_date: this.from_date,
				to_date: this.to_date,
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiImmediatePayment(param);
			this.root = data.value;
		},
		async index() {
			const { data } = await apiIndex();
			this.salesGroups = data.salesGroupList;
		},
		async reportPrint() {
			const reportTemplate = await apiGetBase64ReportTemplate('immediatePayment', reportMrtUrl('immediatePayment'));
			const report = new Report(reportTemplate, this.root, 'immediatePayment');
			this.$store.commit('setReport', report);
		},
		reset() {
			this.sales_group_code = '';
		},
		lineNumber() {
			this.itemIndex += 1;
			return this.itemIndex;
		},
		exportExcel() {
			exportExcel('excelTable', 'ImmediatePayment');
		},
	},
	computed: {},

	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_immediatePayment');
		this.$store.commit('setSubTitle', 'Report -> Immediate Payment');
		this.index();
	},
};
</script>
